import ossupLoad from './single.vue'
export default ossupLoad
